import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { ProveedorCreateInterface } from "../../interfaces/proveedorInterfaces/ProveedorCreate.interface";
import { proveedoreFindOneResponseInterface } from "../../interfaces/proveedorInterfaces/ProveedorFindOne.interface ";

export async function FindOneProveedorAction (
    proveedorId: string
): Promise<ApiResponse<proveedoreFindOneResponseInterface>> {
   const {data} = await apiClient.get(`gpProveedoresProducto/${proveedorId}`);
    return {
        status: 200,
        data,
        message: "Proveedor de producto obtenida correctamente",
    };
}